export default "__VITE_ASSET__DvsJDSGq__"